import { ConfigService } from './config.service';

/**
 * Initializes AppConfigService.
 *
 * @param appConfigService
 */
export function configFactory(appConfigService: ConfigService): any {
  return () => appConfigService.load();
}
